export function validaNomeCompleto(nome: string): boolean {
  const valor = nome.trim();
  const regex = /^([A-Za-zÀ-ÿ]{2,})(\s+[A-Za-zÀ-ÿ]{2,})+$/;
  return regex.test(valor);
}
